import { useEffect, useState, useContext, useCallback } from 'react';
import { localStorage, ViewerContext } from 'dash-ui';
import { useGetAccountQuery } from 'gql/generated.graphql';

const useInitViewer = () => {
  const [isReady, setIsReady] = useState(false);
  const { tokens, setAccount, setTokens } = useContext(ViewerContext);
  const { accessToken } = tokens;
  const {
    loading: isViewerLoading,
    data: accountData,
    error,
  } = useGetAccountQuery({ skip: !accessToken, fetchPolicy: 'no-cache' });
  const account = accountData?.getAccount;

  useEffect(() => {
    if (!isViewerLoading) {
      if (account && setAccount) {
        setAccount(account);
      }
      if (error) {
        console.error('---useInitUser -->', error);
      }
      setIsReady(true);
    }
  }, [isViewerLoading, setAccount, account, error]);

  const onLocalStorageChanged = useCallback(() => {
    if (setTokens) {
      setTokens({
        accessToken: localStorage.getAccessToken() || '',
        refreshToken: localStorage.getRefreshToken() || '',
        refreshTokenExpiry: localStorage.getRefreshTokenExpiry() || '',
      });
    }
  }, [setTokens]);

  useEffect(() => {
    window.addEventListener('storage', onLocalStorageChanged);
    return () => {
      window.removeEventListener('storage', onLocalStorageChanged);
    };
  }, [onLocalStorageChanged]);
  return [isReady];
};
export default useInitViewer;
